<template>
  <modal
    heading="Report"
    subheading="Help us understand what's wrong."
    modal-class="-flag"
    body-class=""
    :handle-close-click="handleCloseClick"
  >
    <form v-if="step === 'form'" class="modal__form" @submit.prevent="submit($event)">
      <div v-for="radio in radios" :key="radio.key" class="radio">
        <input
          :id="radio.key"
          v-model.lazy="picked"
          :value="radio.key"
          :name="`${flaggableType}_radio`"
          class="sr-only"
          type="radio"
        />
        <label :for="radio.key"
          ><span>{{ radio.val }}</span></label
        >
      </div>
      <div class="form__group">
        <label for="reason" class="sr-only">Reason</label>
        <textarea
          id="reason"
          v-model.lazy.trim="reason"
          name="reason"
          placeholder="Reason (optional)"
          rows="1"
        />
      </div>
      <div class="action__group">
        <button class="btn -link" @click.prevent="handleCloseClick">
          Cancel
        </button>
        <button :disabled="makingApiCall" class="btn -main">
          Report
        </button>
      </div>
    </form>

    <div v-if="step === 'end'" class="modal__body">
      <p>
        You’ve selected <strong>{{ pickedText }}</strong
        >. We will look into this and resolve any issues based on your report. Thank you!
      </p>
      <button @click="step = 'form'">
        Change Selection
      </button>
    </div>

    <footer v-if="step === 'end'" class="modal__footer">
      <button @click.prevent="handleCloseClick">
        Close Window
      </button>
    </footer>
  </modal>
</template>

<script>
import modal from './modal.vue'
import { fbAPIPost } from 'app/utils/http-api'

export default {
  name: 'ModalFlag',
  components: { modal },
  props: {
    /* eslint-disable vue/require-default-prop */
    handleCloseClick: Function,
    id: Number,
    flaggableType: String,
  },
  data() {
    return {
      picked: 'spam',
      reason: '',
      step: 'form',
      pickedText: '',
      makingApiCall: false,
      radios: [
        {
          id: 1,
          key: 'spam',
          val: 'Unwanted commercial content or spam',
        },
        {
          id: 2,
          key: 'pornography',
          val: 'Pornography or sexually explicit material',
        },
        {
          id: 3,
          key: 'hate_speech',
          val: 'Hate speech or graphic violence',
        },
        {
          id: 4,
          key: 'bullying',
          val: 'Harassment or bullying',
        },
      ],
    }
  },
  methods: {
    submit() {
      const flag = this.radios.filter(radio => this.picked === radio.key)[0]
      const reason = this.reason || flag.val

      this.pickedText = flag.val

      this.makingApiCall = true

      const formData = new window.FormData()
      formData.append('flaggable_type', this.flaggableType)
      formData.append('flaggable_id', this.id)
      formData.append('reason', reason)
      formData.append('report_type_id', flag.id)

      fbAPIPost(
        `flag/add`,
        formData,
        res => {
          this.makingApiCall = false
          this.step = 'end'
        },
        errr => {
          this.makingApiCall = false
          this.handleCloseClick()
        },
      )
    },
  },
}
</script>
